module.exports = __webpack_public_path__ + "static/img/icon_default_store_img.ce885d9c.png";